<template>
  <div class="box">
    <div class="topheader margin w  drRtl">
      <div class="topHeader__RightBox">
        <div v-if="$root.globalData" class="lang">
          <EarthIcon v-if="cuurentCountryFlag==null"  class="earthIcon" />
          <img v-else :src="cuurentCountryFlag" @click="showLanguageBox()" alt="country flag">
          <select v-model="language" id="selectLanguage" class="Lang__Change">
            <option v-for="(item, index) in $root.globalData.languages"
            :selected="index==0?'selected':''"
             :key="index" :value="item.name">{{item.label}}</option>
          </select>
        </div>
        <div class="time">
          <span id="demo"></span>
        </div>
      </div>
      <div class="topHeader__LeftBox">
        <div class="social">
          <a :href="$root.globalData.settings.social_whatsapp"><Whatsapp class="social__logo" /></a>
          <a :href="$root.globalData.settings.social_twitter"><Twitter class="social__logo" /></a>
          <a :href="$root.globalData.settings.social_telegram"><Telegram class="social__logo" /></a>
          <a :href="$root.globalData.settings.social_instagram"><Instagram class="social__logo" /></a>
        </div>

        <div class="phone">
          <span> {{$root.globalData.settings.header_phone}} <PhoneIconWhite class="phoneIcon" /> </span>
        </div>

        <!-- <div class="panel">پنل کاربری <UserIcon class="useriIcon" /></div> -->
      </div>
    </div>
  </div>
</template>

<script>
import EarthIcon from "../svgs/EarthIcon.vue";
import UserIcon from "../svgs/UserIcon.vue";
import Telegram from "../svgs/Telegram1.vue";
import Instagram from "../svgs/Instagram1.vue";
import Twitter from "../svgs/Twitter.vue";
import Whatsapp from "../svgs/Whatsapp.vue";
import Callicon from "../svgs/Callicon.vue";
import PhoneIconWhite from "../svgs/PhoneIconWhite.vue";

export default {
  data() {
    return {
      cuurentCountryFlag:null,
      persianInterVal: null,
      language:""
    };
  },
   
  watch:{
    language(newVal){
      if(newVal!=this.$cookie.get('language')){
        this.$cookie.set('language',newVal)
        this.$axios.defaults.headers.common['accept-language'] = newVal;
        this.$router.go(0)
      }
      let flag=null;
      this.$root.globalData.languages.forEach(lang => {
        if(lang.name==newVal&&lang.flag!=null&&lang.flag!=''){
          flag=lang.flag
        }
      });
      this.cuurentCountryFlag=flag;
    }
  },
  components: {
    EarthIcon,
    UserIcon,
    Telegram,
    Instagram,
    Twitter,
    Whatsapp,
    Callicon,
    PhoneIconWhite
  },
  // persian date and time
  mounted() {
    if(this.$cookie.get('language')){
      this.language=this.$cookie.get('language')
    }else{
      this.language="fa"
      this.$cookie.set('language','fa')

    }


  },
  methods: {
   
    showLanguageBox() {
      document.getElementById("selectLanguage").focus();
      document.getElementById("selectLanguage").click();
    }
  }
};
</script>
<style scoped>
/* top header rightbox  */
.lang img{
  width:20px;
  position: absolute;
}
.box {
}
.topheader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #fff;
}
.time {
  display: none;
  font-size: 14px;
  letter-spacing: 1px;
  background-color: #0d6efd;
  color: #fff;
  padding: 10px;
  border-radius: 10px;
}

.topHeader__RightBox {
  display: flex;
  align-items: center;
  font-size: 16px;
  padding-left: 1rem;
}

.lang {
  display: flex;
  align-items: center;
  /* border-left: 2px solid rgba(255, 255, 255, 0.425); */
  /* padding: 10px; */
  position: relative;
}

.Lang__Change {
  background-color: transparent;
  color: #fff;
  outline: none;
  padding: 0 10px;
}

.Lang__Change option {
  background-color: #333;
  padding: 5px;
}

/* topheader leftbox   */

.topHeader__LeftBox {
  display: flex;
  align-items: center;
  font-size: 13px;
}

.social,
.phone,
.panel {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.phone {
  /* border-left: 2px solid rgba(255, 255, 255, 0.425); */
  border-right: 2px solid rgba(255, 255, 255, 0.425);
}

.phone span {
  display: flex;
  align-items: center;
}
.social {
}

.social__logo:hover {
  transform: scale(1.2);
}

.phone {
  margin: 0 10px;
  padding: 5px 10px;
}
.panel {
  margin-right: 10px;
}

@media only screen and (max-width: 768px) {
  .topheader {
    width: 100%;
    padding: 0;
    border-bottom: rgb(214, 214, 214) 1px solid;
  }

  .time {
    display: block;
  }

  .topHeader__LeftBox {
    display: none;
  }
  /* .topHeader__RightBox {
    justify-content: space-between;
    background-color: #fff;
    width: 100%;
    color: #000;
  } */
.topHeader__RightBox {
  display: none;}
  .topHeader__RightBox select,
  option {
    color: #000;
  }

  .earthIcon {
    margin-right: 2rem;
  }
}
.Lang__Change {
  padding: 1rem 0px;
      z-index: 10;
    padding-right: 1.7rem;
}

.Lang__Change option {
  padding: 1rem;
  color: #fff;
}
</style>

<style>
@media only screen and (max-width: 768px) {
  .earthIcon path {
    fill: #000;
  }
}
</style>
